/**
 * showings-time-window.ts
 *
 * Pure window-type module for the Leasing Dashboard's Upcoming Showings card.
 * Modeled on dashboard-time-window.ts: dependency-free (no component imports)
 * so it stays unit-testable without pulling in browser-only providers.
 *
 * Unlike computeSince() in dashboard-time-window.ts, this module does no date
 * math itself — the window VALUE (`'today' | '2d' | 'week'`) is sent to the
 * server as-is, and the boundary layer (leasing-dashboard.routes.ts /
 * computeWindowEnd) computes the actual window end. This is still a
 * cross-property aggregate view (portfolio-wide upcoming showings span
 * multiple listings/properties, so there is no single property timezone to
 * anchor on) — see dashboard-time-window.ts and
 * docs/claude/timezone-policy.md Rule 3 for the same reasoning applied there.
 */

export type ShowingsTimeWindow = 'today' | '2d' | 'week';

/** Pass-through — the window value IS the query param the boundary expects. */
export function computeWindowParam(w: ShowingsTimeWindow): ShowingsTimeWindow {
  return w;
}

export const SHOWINGS_TIME_WINDOW_LABELS: Record<ShowingsTimeWindow, string> = {
  today: 'Today',
  '2d': '2 days',
  week: 'Week',
};
